package world.phantasmal.web.core.observable

fun <T> emitter(): Emitter<T> = Emitter()
